import React, { useState, useEffect } from "react";
import IndonesiaFlag from "../../../assets/images/Icons/icons/indonesia_flag.png";
import EnglandFlag from "../../../assets/images/Icons/icons/england_flag.png";
import { withTranslation } from "react-i18next";
import {
  makeAjax,
  url,
  respStatus,
  showMessage,
} from "../../../helpers/global_helper";

const LanguageItemMobile = (props) => {
  const [selectedLang, setSelectedLang] = useState(
    localStorage.getItem("I18N_LANGUAGE") || "id"
  );
  const langList = {
    en: {
      label: "English",
      short_label: "Eng",
      flag: EnglandFlag,
    },
    id: {
      label: "Indonesia",
      short_label: "Ind",
      flag: IndonesiaFlag,
    },
  };

  const toggleLang = (lang) => {
    setSelectedLang(lang);
    localStorage.setItem("I18N_LANGUAGE", lang);
    let reqData = { lang: lang };
    makeAjax(
      url.PLAYER_API.updateUserLanguage,
      reqData,
      url.PLAYER_MS_EXT
    ).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      props.i18n.changeLanguage(lang);
    });
  };

  return (
    <>
      <div
        className="language-div"
        onClick={() => toggleLang(selectedLang === "id" ? "en" : "id")}
      >
        <div className="menu_icon">
          <button
            className={`theme-toggle switch ${selectedLang}`}
            onClick={() => toggleLang(selectedLang === "id" ? "en" : "id")}
            aria-label="Toggle language"
          >
            <span className={`slider ${selectedLang === "id" ? "id" : "en"}`}>
              <div
                className={`icon sun-icon ${selectedLang === "id" ? "active" : ""
                  }`}
              >
                <img
                  src={IndonesiaFlag}
                  alt="Indonesian Flag"
                  className="header-icon"
                />
              </div>
              <div
                className={`icon moon-icon ${selectedLang === "en" ? "active" : ""
                  }`}
              >
                <img
                  src={EnglandFlag}
                  alt="English Flag"
                  className="header-icon"
                />
              </div>
            </span>
          </button>
        </div>
        <p className="theme-label">{langList[selectedLang].label}</p>
      </div>
    </>
  );
};

export default withTranslation()(LanguageItemMobile);
